import React from 'react'
import { Link } from 'gatsby'
import Image from "../../components/image";

const HomeHistory = ({ content }) => {

    if (typeof content === 'undefined' || !content) {
        return null;
    }

    return (
        <section className='Home__history'>
            <Image source={content.background} imgClass="Home__history__bg" />
            <div className="Container">
                <div className="Home__history__wrap">
                    <div className="col-3 Home__history__left">
                        <Image source={content.leftImage} />
                    </div>
                    <div className="col-6 Home__history__content">
                        <h2>{content.title}</h2>
                        <p>{content.text}</p>
                        <Link to={content.button.url} className="Button Button__primary">{content.button.title}</Link>
                    </div>
                    <div className="col-3 Home__history__right">
                        <Image source={content.rightImage} />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default HomeHistory